// Angular
import { Component, Input, Output, EventEmitter } from '@angular/core';

// Afidium
import { GenericField, IGenericField } from '../generic-field';
import { IFieldSpecs } from '../interfaces/field-specs';

/**
 * Rating-field
 * Generate rating field
 * @extends GenericField
 * @implements IGenericField
 */
@Component({
    
    selector: 'rating-field',
    templateUrl: './rating-field.component.html',
    styleUrls: ['./rating-field.component.scss']
})
export class RatingFieldComponent {
    @Input()
    public fieldConfig: IFieldSpecs;

    @Input()
    public options: object;

    @Input()
    public numberOfStars: number = 5;

    @Output()
    public change: EventEmitter<null> = new EventEmitter();

    @Output()
    public cancel: EventEmitter<null> = new EventEmitter();
}
